import axios from "axios";

import UAParser from 'ua-parser-js'

export function getParameterByName(name, url) {
	name        = name.replace(/[[]]/g, '\\$&');
	let regex   = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	    results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function setCookie(c_name, value, exdays) {
	var exdate = new Date();
	exdate.setDate(exdate.getDate() + exdays);
	var c_value     = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
	document.cookie = c_name + "=" + c_value;
}

export function getCookie(c_name) {
	var i, x, y, ARRcookies = document.cookie.split(";");
	for (i = 0; i < ARRcookies.length; i++) {
		x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
		y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
		x = x.replace(/^\s+|\s+$/g, "");
		if (x == c_name) {
			return unescape(y);
		}
	}
}

function setUtmParams() {
	['utm_source', 'utm_campaign', 'utm_medium'].forEach(v => {
		let query_param = getParameterByName(v, window.location.href);
		if (query_param) {
			setCookie(v, query_param, 2)
		}
	})
}

function isAndroidDevice() {
	return /Android/i.test(navigator.userAgent);
}

function isIOSDevice() {
	return /iPhone|iPad|iPod/i.test(navigator.userAgent)
		|| (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
}

function isMobileDevice() {
	return isIOSDevice() || isAndroidDevice();
}

function appStoreLink() {
	if (typeof window.gtag === 'function') {
		window.gtag('event', 'app_store_download_link_clicked', {});
	}

	let utm_source        = getCookie('utm_source') || null;
	let utm_campaign      = getCookie('utm_campaign') || null;
	let utm_medium        = getCookie('utm_medium') || null;
	const parser          = new UAParser(window.navigator.userAgent);
	const {name, version} = parser.getOS()
	const {vendor, model} = parser.getDevice();
	axios({
		method: 'post',
		url: process.env.REACT_APP_API_URL + '/event/send',
		data: {
			screen_width: window.screen.availWidth,
			screen_height: window.screen.availHeight,
			utm_source,
			utm_campaign,
			utm_medium,
			timezone: new Date().getTimezoneOffset(),
			os_version: version,
			os: name?.toLowerCase(),
			brand: vendor?.toLowerCase(),
			model: model?.toLowerCase()
		},
		headers: {"Content-Type": "application/json"}
	})
	if (isIOSDevice()) {
		if (utm_source === 'instagram') {
			window.location.href = 'https://apps.apple.com/app/apple-store/id6444854210?pt=122044178&ct=instagram&mt=8';
		} else {
			window.location.href = 'https://apps.apple.com/us/app/barkr-meet-dog-owners/id6444854210';
		}
	} else if (isAndroidDevice()) {
		window.location.href = 'https://play.google.com/store/apps/details?id=com.barkr.barkr';
	} else {
		window.location.replace('/');
	}
}

export {
	appStoreLink,
	isMobileDevice,
	setUtmParams
};
